import Vue from 'vue'

//only insights show up as tiles
//everybody uses the same viewmodel though

Vue.component('ArticleTile', {
  template: '#article-tile',
  props: ['link', 'image', 'icon', 'date', 'readingtime', 'source']
})